module.exports = __webpack_public_path__ + "img/PopUpBanner_AM_Halloween-premio04.cbf90430.png";